{
  "city-card": {
    "text": {
      "explore-top-salons": "Khám phá các salon hàng đầu tại"
    }
  }
}
